import React from 'react';

export interface EmojiProps {
    "aria-label": string,
    "emoji": string,
}

export const Emoji: React.FC<EmojiProps> = (props) => {
    return <span role="img" aria-label={props["aria-label"]}>{props.emoji}</span>;
}

(Emoji as any).displayName = "Emoji";